const BACKEND = "https://connect.starfishadvance.com";

// ── Token management ────────────────────────────────────────────────
export const getToken = () => sessionStorage.getItem("mca_token");
export const setToken = (token) => sessionStorage.setItem("mca_token", token);
export const clearToken = () => sessionStorage.removeItem("mca_token");

// ── Authenticated fetch wrapper ─────────────────────────────────────
export async function authFetch(url, options = {}) {
  const token = getToken();
  if (!token) throw new Error("Not authenticated");

  const res = await fetch(url, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      ...options.headers,
    },
  });

  if (res.status === 401 || res.status === 403) {
    clearToken();
    window.location.reload();
    throw new Error("Session expired");
  }

  return res;
}

// ── Auth ─────────────────────────────────────────────────────────────
export async function login(username, password) {
  const res = await fetch(`${BACKEND}/api/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ username, password }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || "Login failed");
  return data;
}

export async function verifyToken() {
  const token = getToken();
  if (!token) return false;
  const res = await fetch(`${BACKEND}/api/verify`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.ok;
}

// ── Merchants ───────────────────────────────────────────────────────
export async function fetchMerchants() {
  const res = await authFetch(`${BACKEND}/api/merchants`);
  const data = await res.json();
  return data.merchants || [];
}

export async function fetchTransactions(merchantId, days = 120) {
  const res = await authFetch(`${BACKEND}/api/transactions`, {
    method: "POST",
    body: JSON.stringify({ merchant_id: merchantId, days }),
  });
  const data = await res.json();
  if (data.error) throw new Error(data.error);
  return data;
}

export async function renameMerchant(merchantId, newName) {
  const res = await authFetch(`${BACKEND}/api/merchants/${merchantId}`, {
    method: "PATCH",
    body: JSON.stringify({ merchant_name: newName }),
  });
  const data = await res.json();
  if (data.error) throw new Error(data.error);
  return data;
}

export async function deleteMerchant(merchantId) {
  const res = await authFetch(`${BACKEND}/api/merchants/${merchantId}`, {
    method: "DELETE",
  });
  const data = await res.json();
  if (data.error) throw new Error(data.error);
  return data;
}

// ── Settings ────────────────────────────────────────────────────────
export async function fetchSettings() {
  const res = await authFetch(`${BACKEND}/api/settings`);
  const data = await res.json();
  return data.settings || {};
}

export async function updateSettings(settings) {
  const res = await authFetch(`${BACKEND}/api/settings`, {
    method: "PUT",
    body: JSON.stringify({ settings }),
  });
  const data = await res.json();
  if (data.error) throw new Error(data.error);
  return data.settings;
}
export async function setTransactionFlag(merchantId, txnKey, flag) {
  const res = await authFetch(`${BACKEND}/api/merchants/${merchantId}/flags`, {
    method: "PUT",
    body: JSON.stringify({ txn_key: txnKey, flag }),
  });
  const data = await res.json();
  if (data.error) throw new Error(data.error);
  return data;
}

// ── Users ───────────────────────────────────────────────────────
export async function fetchUsers() {
  const res = await authFetch(`${BACKEND}/api/users`);
  const data = await res.json();
  return data.users || [];
}

export async function createUser(username, password, role) {
  const res = await authFetch(`${BACKEND}/api/users`, {
    method: "POST",
    body: JSON.stringify({ username, password, role }),
  });
  const data = await res.json();
  if (data.error) throw new Error(data.error);
  return data;
}

export async function deleteUserById(id) {
  const res = await authFetch(`${BACKEND}/api/users/${id}`, {
    method: "DELETE",
  });
  const data = await res.json();
  if (data.error) throw new Error(data.error);
  return data;
}